import React from 'react';
import { BarChart2, Clock } from 'lucide-react';
import type { User } from '../types';

interface ClientPortalReportingComingSoonProps {
  user?: User | null;
}

/** Klantportaal: volledige rapportage-module volgt later; voorkomt lege / foutieve KPI's. */
const ClientPortalReportingComingSoon: React.FC<ClientPortalReportingComingSoonProps> = ({ user }) => {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-gradient-to-b from-slate-50 via-white to-red-50/20">
      <div className="shrink-0 border-b border-slate-200/60 bg-white/80 px-4 py-3 backdrop-blur-md md:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-[#e51b23] to-red-700 shadow-sm">
            <BarChart2 size={15} className="text-white" />
          </div>
          <div>
            <h1 className="text-[15px] font-bold text-slate-900">Rapportage</h1>
            <p className="text-[11px] font-medium text-slate-400">Klantportaal</p>
          </div>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center p-6 md:p-10">
        <div className="max-w-md rounded-2xl border border-slate-200/80 bg-white p-8 text-center shadow-sm ring-1 ring-slate-100">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 text-[#e51b23]">
            <Clock size={28} strokeWidth={2} />
          </div>
          <p className="text-[10px] font-black uppercase tracking-widest text-[#e51b23]">Binnenkort beschikbaar</p>
          <h2 className="mt-2 text-lg font-bold text-slate-900">Rapportage komt eraan</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            We werken aan inzichten voor vacatures, shortlist en pipeline — afgestemd op{' '}
            {user?.clientName ? (
              <span className="font-semibold text-slate-800">{user.clientName}</span>
            ) : (
              'uw organisatie'
            )}
            .
          </p>
          <p className="mt-4 text-[11px] leading-relaxed text-slate-500">
            Gebruik tot die tijd <span className="font-semibold text-slate-700">Pipeline</span>,{' '}
            <span className="font-semibold text-slate-700">Shortlist</span> en{' '}
            <span className="font-semibold text-slate-700">Te beoordelen</span> voor actuele kandidaten en
            vacatures.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClientPortalReportingComingSoon;
